<template>
    <!-- 颈部功能结论区域。 -->
    <div class="neck-assess-data body-thermal-wrapper">
        <!-- 颈部功能结论卡片。 -->
        <div class="neck-assessment-list data-problem">
            <!-- 正常结论标题。 -->
            <div v-if="!isAbnormal">
                <!-- 正常结论图标。 -->
                <img src="@/assets/images/report_completion_icon.png" alt class="conclusion-icon" />
                <!-- 正常结论名称。 -->
                <p class="name">{{ $t('neckReport.conclusion') }}</p>
            </div>
            <!-- 遍历后端返回的颈部结论。 -->
            <template v-for="(item, index) in conclusion">
                <!-- 异常结论标题。 -->
                <p v-if="isAbnormal" :key="`${index}-title`" class="title">{{ item.title }}</p>
                <!-- 正常结论内容。 -->
                <p v-else :key="`${index}-conclusion`" class="conclusion">{{ item.title }}</p>
                <!-- 存在分析内容时展示分析与建议。 -->
                <div v-if="item.msg" :key="`${index}-message`" class="last-suggest">
                    <!-- 分析内容。 -->
                    <div class="suggest-row">
                        <!-- 分析图标。 -->
                        <img src="@/assets/images/report_completion_icon.png" alt class="row-icon" />
                        <!-- 分析文案。 -->
                        <div class="row-body">
                            <!-- 分析标题。 -->
                            <h5 class="row-head">{{ $t('neckReport.analysis') }}</h5>
                            <!-- 后端返回的本地化分析。 -->
                            <p class="row-content">{{ item.msg }}</p>
                        </div>
                    </div>
                    <!-- 固定建议内容。 -->
                    <div class="suggest-row">
                        <!-- 建议图标。 -->
                        <img src="@/assets/images/report_suggest_icon.png" alt class="row-icon" />
                        <!-- 建议文案。 -->
                        <div class="row-body">
                            <!-- 建议标题。 -->
                            <h5 class="row-head">{{ $t('neckReport.suggestion') }}</h5>
                            <!-- 固定建议文本。 -->
                            <p class="row-content">{{ $t('neckReport.suggestionText') }}</p>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
// 引入颈部功能结论查询。
import { findBsNeckConclusion } from '@/assets/js/apolloGql.js'

// 导出颈部功能结论组件。
export default {
    // 声明报告基础信息。
    props: {
        // 当前报告信息。
        massInfo: Object,
    },
    // 初始化组件状态。
    data() {
        // 返回结论状态。
        return {
            // 保存接口返回的结论。
            conclusion: [],
            // 标记是否存在异常结论。
            isAbnormal: false,
        }
    },
    // 组件挂载后查询颈部结论。
    mounted() {
        // 加载颈部功能结论。
        this.loadNeckConclusion()
    },
    // 声明组件方法。
    methods: {
        // 查询颈部功能结论。
        loadNeckConclusion() {
            // 发起 GraphQL 查询。
            this.$apollo.query({
                // 使用颈部功能查询文档。
                query: findBsNeckConclusion,
                // 设置查询参数。
                variables: {
                    // 当前会员 ID。
                    memberId: this.massInfo.memberId,
                    // 当前扫描 ID。
                    scanId: this.massInfo.scanId,
                    // 当前扫描时间。
                    scanTime: String(this.massInfo.createTime),
                },
                // 始终读取最新数据。
                fetchPolicy: 'network-only',
            }).then((res) => {
                // 提取颈部功能响应。
                const result = res.data.bsNeckConclusion
                // 仅处理成功响应。
                if (result && result.code === 200 && result.data) {
                    // 保存结论列表。
                    this.conclusion = result.data.conclusion || []
                    // 根据分析文案判断是否存在异常。
                    this.isAbnormal = this.conclusion.some((item) => Boolean(item.msg))
                }
            })
        },
    },
}
</script>

<style lang="less" scoped>
/* 颈部功能结论外层样式。 */
.neck-assess-data {
    padding: 10px;

    /* 颈部功能结论卡片样式。 */
    .neck-assessment-list {
        position: relative;
        width: 353px;
        margin: 0 auto;
        color: #ffffff;
        background: url(../../assets/images/report/bj1.png) center no-repeat;
        background-size: 100% 100%;
        padding-bottom: 15px;

        /* 正常结论名称样式。 */
        .name {
            padding-top: 21px;
            margin: 0 8px 4px 39px;
            font-size: 15px;
            line-height: 22px;
            text-align: left;
        }

        /* 正常结论图标样式。 */
        .conclusion-icon {
            position: absolute;
            top: 23px;
            left: 14px;
            width: 16px;
            height: 16px;
        }

        /* 正常结论文本样式。 */
        .conclusion {
            margin: 0 8px 0 39px;
            font-size: 14px;
            text-align: left;
        }

        /* 异常结论标题样式。 */
        .title {
            padding: 22px 10px 5px 39px;
            font-size: 13px;
            color: #e64444;
            text-align: left;
            background: url(../../assets/images/report/notice.png) no-repeat 11px 23px;
        }

        /* 分析与建议容器样式。 */
        .last-suggest {
            padding: 10px 14px 20px;
        }

        /* 分析与建议行样式。 */
        .suggest-row {
            display: flex;
            align-items: flex-start;
            padding-bottom: 12px;
        }

        /* 最后一行不保留底部间距。 */
        .suggest-row:last-child {
            padding-bottom: 0;
        }

        /* 分析与建议图标样式。 */
        .row-icon {
            width: 16px;
            height: 16px;
            flex-shrink: 0;
            margin-top: 1px;
        }

        /* 分析与建议正文容器。 */
        .row-body {
            flex: 1;
            min-width: 0;
            padding-left: 9px;
            text-align: left;
        }

        /* 分析与建议标题样式。 */
        .row-head {
            margin: 0 0 6px;
            font-size: 12px;
            font-weight: 400;
        }

        /* 分析与建议正文样式。 */
        .row-content {
            margin: 0;
            font-size: 12px;
            line-height: 17px;
            color: #8aa3be;
        }
    }
}
</style>
